import React from "react";

const LeftWindowtext = ({ image }) => {
  return (
    <>
    
    <style>{`
        .left-panel {
          display: none;
        }
        @media (min-width: 716px) {
          .left-panel {
            display: flex;
          }
        }
      `}</style>

      <div
        className="left-panel"
        style={{
          height: "100%",
          width: "50%",
          paddingLeft: "2rem",
          paddingRight: "2rem",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "0 30px 30px 0",
          background: "#041c44",
        }}
      >
      <div
        style={{
          border: "1px solid rgba(255,255,255,0.4)",
          borderRadius: "20px", 
          padding: "1.5rem",
          textAlign: "center",
          width: "60%",
          backdropFilter: "blur(12px)",
          backgroundImage:
            "linear-gradient(to left top, rgba(255,255,255,0.2), rgba(255,255,255,0))",
        }}
      >
        <h1
          style={{
            fontFamily: "poppins",
            fontSize: "32px",
            fontWeight: "700",
            lineHeight: "40px",
            color: "white",
          }}
        >
          Job Role Management System By
        </h1>

        <div
          style={{
            marginTop: "1.5rem",
          }}
        >
          <img
            src={image}
            alt="Company Logo"
            style={{
              width: "50%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </div>
      </div>
    </div></>
  );
};

export default LeftWindowtext;
